export const WEB_LINK = 'WebLink';
export const ANCHOR_LINK = 'AnchorLink';
